export const ABBREVIATION_LOOKUP_TEST_ID = 'AbbreviationLookup';

export const NO_MATCHING_RESULTS_LABEL = 'No matching results';
export const START_TYPING_NOTIFICATION_LABEL =
  'Start typing atom or template structure name';

export const MIN_LOOKUP_VALUE_LENGTH_FOR_HIGHLIGHT = 2;
